'use strict';

var tooltip = require('app_rws/components/toolTip');
var baseSearch = require('base/search/search');
var matchBreakpoints = require('../util/matchBreakpoints');

/**
* Update url to match current search and paging state
* @return {undefined}
*/
function updateSearchUrl() {
    const permalink = document.querySelector('.permalink');
    if (permalink && /^https?:\/\//.test(permalink.value)) {
        history.replaceState(null, null, permalink.value);
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * Additionaly reinitialize tooltips
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    tooltip.init();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        $results
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active');
    });

    updateDom($results, '.refinements');
}

/**
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleGridHeader($results) {
    updateDom($results, '.grid-header');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.grid-header': handleGridHeader
    };

    // Update DOM elements that do not require special handling
    [
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.js-sort-order'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Add more tiles and add focus to next tile
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function addTiles(response) {
    var $newHtml = $($.parseHTML(response));
    var firstItemLink = $newHtml.filter('.st-product-grid__item').first().find('.c-product-tile__image-container a');
    setTimeout(function () {
        $(firstItemLink).focus();
    }, 500);
    $('.grid-footer').replaceWith($newHtml);
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

if (typeof Object.assign !== 'function') {
    Object.assign = function (target, varArgs) {
        if (target == null) { // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) { //eslint-disable-line
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

function loadArticles() {
    var $tabs = $('.js-nav-tabs-wrapper');
    if ($tabs.length && $tabs.data('has-content') === true) {
        $('.js-tab-link-content').trigger('click');
    }
}

module.exports = Object.assign(baseSearch, {
    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    // Customization: Added focus to first item
                    addTiles(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li a, .refinements li button, .refinement-bar .reset, .filter-value a, .swatch-filter a',
            function (e) { //eslint-disable-line
                var attributeId = '#' + $(this).find('span').last().attr('id');
                var $this = $(this);
                var url = $this.data('href');
                if ($(this).hasClass('category')) {
                    window.location = $(this).attr('href');
                    return true;
                }
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: url,
                    data: {
                        page: $('.grid-footer').data('page-number')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        updateSearchUrl();
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    }
                });
            });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    // reinit tooltips
                    tooltip.init();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    toggleRefinementPanel: function () {
        // Handle refinement panel toggle
        $('.container').on('click', '.js-refinement-toggle', function (e) {
            e.preventDefault();
            var $refinementPanel = $('.js-refinement-panel');
            if (matchBreakpoints(['sm-up', 'md-up', 'lg-up', 'xl-up'])) {
                if ($refinementPanel.hasClass('show')) {
                    $refinementPanel.removeClass('show');
                    $refinementPanel.attr('aria-hidden', true);
                    $(this).attr('aria-expanded', false);
                    // Hide the the refinement panel and create a 4up product grid.  Show any applied filters
                    $('.js-grid-container').removeClass('col-md-9');
                    $('.js-product-grid-item').removeClass('col-sm-4').addClass('col-sm-3');
                    $('.js-refinement-toggle--close').addClass('d-none').removeClass('d-inline-flex');
                    $('.js-refinement-toggle--open').addClass('d-inline-flex');
                    $('.js-filter-bar').removeClass('d-md-none');
                } else {
                    // Show the refinement panel and create a 3up product grid.  Hide any applied filters
                    $refinementPanel.addClass('show');
                    $refinementPanel.attr('aria-hidden', false);
                    $(this).attr('aria-expanded', true);
                    $('.js-grid-container').addClass('col-md-9');
                    $('.js-product-grid-item').removeClass('col-sm-3').addClass('col-sm-4');
                    $('.js-refinement-toggle--close').addClass('d-inline-flex');
                    $('.js-refinement-toggle--open').addClass('d-none').removeClass('d-inline-flex');
                    $('.js-filter-bar').addClass('d-md-none');
                }
            }
        });
    },

    closeRefinementPanel: function () {
        // Handle refinement panel close
        $('.container').on('click', '.js-close-mobile-refinement-panel', function (e) {
            $('.js-refinement-bar, .modal-background').hide();
        });
    },

    loadArticles: loadArticles
});
